module.exports = __webpack_public_path__ + "static/media/SarahSwitek_02_HowAreYouFeeling_1.8792bb6b.mp3";